import React from 'react'
import {connect} from "react-redux"
import {colors} from "../../utils/styles"

const wrapperStyle = {
  display: 'flex',
  alignItems: 'center',
  fontSize: '14px',
  color: colors.mocTextTertiary
}

const logoStyle = {
  width: "16px",
  height: "16px"
}

const defaultLinkStyle = {
  fontWeight: 400,
  display: "flex",
  alignItems: "center"
}

const currentLinkStyle = {
  fontWeight: 700,
  color: colors.mocTextSecondary
}

const separatorStyle = {
  margin: "0 8px",
  color: colors.mocTextTertiary
}

class BreadCrumbs extends React.Component {

  state = {
    showOnlyDefaultLinks: false,
  }

  componentDidUpdate(prevProps) {
    const {currentStep} = this.props

    if (currentStep && currentStep !== prevProps.currentStep) {
      this.setState({showOnlyDefaultLinks: false})
    }
  }

  render() {
    const {currentStep} = this.props
    const {showOnlyDefaultLinks} = this.state

    const defaultLinks = [
      {label: 'My OOCL Center', imageSrc: 'images/home-icon.svg'},
      {label: 'Real Time Release'}
    ]

    const shouldShowCurrentStep = currentStep && !showOnlyDefaultLinks

    return (
        <div style={wrapperStyle}>
          {defaultLinks.map((link, idx) => (
              <React.Fragment key={idx}>
                <span
                    style={idx === 1 && !shouldShowCurrentStep
                        ? {...defaultLinkStyle, ...currentLinkStyle}
                        : defaultLinkStyle}
                >
                  {link.imageSrc && (
                      <img
                          src={link.imageSrc}
                          style={{...logoStyle, marginRight: 6}}
                          alt={link.label + " Icon"}
                      />
                  )}
                  {link.label}
                </span>

                {idx !== defaultLinks.length - 1 || shouldShowCurrentStep ? (
                    <span style={separatorStyle}>/</span>
                ) : null}
              </React.Fragment>
          ))}

          {shouldShowCurrentStep && (
              <span style={currentLinkStyle}>{currentStep}</span>
          )}
        </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    userProfile: state.userProfile
  }
}

export default connect(mapStateToProps)(BreadCrumbs)
